import { cn } from '@lib/utils';

/** hero 하단 CTA 2개(문의 버튼·자세히 보기 링크)가 공유하는 캡슐 형태·크기 */
export const pillBase = cn(
  'inline-flex w-fit items-center justify-center rounded-[35.5px] transition-colors',
  'ring-offset-background focus-visible:ring-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
  'h-11 px-4 xl:h-12 xl:px-5 text-[14px] font-semibold leading-[22px] tracking-[-0.128px]',
  '2xl:h-[71px] 2xl:px-[30px] 2xl:text-[20px] 2xl:font-bold 2xl:leading-normal 2xl:tracking-normal',
);

// 시안 호버색 #FF142D 는 14px 흰 글씨에서 3.9:1 로 AA 미달 → 2xl 미만만 어둡게
export const pillHoverRed = cn(
  'hover:bg-3b-red-light-700 hover:text-white',
  '2xl:hover:bg-3b-error-primary',
);

// 포커스 시 지연 없이 노출하고, 동작 줄이기 설정에서는 재생하지 않는다.
export const heroCtaPop =
  'motion-safe:animate-main-hero-cta-pop focus-visible:!animate-none focus-visible:opacity-100 focus-visible:transform-none';
